import { Routes, Route } from 'react-router-dom';

import Tracking from '@pages/keyword/tracking';
import Optimization from '@pages/keyword/optimization';
import Insight from '@pages/keyword/insight';
import Suggestion from '@pages/keyword/suggetion';
import Research from '@pages/keyword/research';
import Trends from '@pages/keyword/trends';
import Localization from '@pages/keyword/localization';

const KeywordRoutes = () => {
  return (
    <Routes>
      <Route path="/tracking" element={<Tracking />} />
      <Route path="/optimization" element={<Optimization />} />
      <Route path="/research" element={<Research />} />
      <Route path="/suggestion" element={<Suggestion />} />
      <Route path="/insight" element={<Insight />} />
      <Route path="/trends" element={<Trends />} />
      <Route path="/localization" element={<Localization />} />
    </Routes>
  );
};

export default KeywordRoutes;
